const lazyLoad = require("../../unit/lazyload/lazyload");

let handleNav = function () {
    $("#categorys-2014").find(".dd-inner .item").bind("mouseenter", function (e) {
        e.preventDefault();
        $(this).addClass("hover").siblings().removeClass("hover");

        $(this).find(".sub-menu .lazy").removeClass("hideImg");

        let subObj = $(this).find(".sub-menu");
        let offsetFocus = $("#categorys-2014 .dd").offset().top;
        let itemOffsetTop = $(this).offset().top;
        let moveY = itemOffsetTop - offsetFocus - 2;

        subObj.css("top", -moveY);
        lazyLoad.fn.init({"root": $(this)})
    });

    $("#navitems-2014").bind("mouseenter", function (e) {
        e.preventDefault();
        unHover();
    });

    $("#categorys-2014").bind("mouseleave", function (e) {
        e.preventDefault();
        unHover();
    });

    function unHover() {
        $("#categorys-2014").find(".dd-inner .item").removeClass("hover");
    }

};

let control = {
    init: function () {
        let self = this;
        self.handleShop();
        self.loadMenu();
        self.changeRoot();
    },
    loadMenu: function () {
        let self = this;
        $("#categorys-2014 .dd").remove();
        $(".leaf-nav").remove();
        $.ajax({
            type: 'POST',
            url: "//www.jd.hk/header/getData.do",
            dataType: "jsonp",
            success: function (data) {
                self.reunderNav(data);
                self.hover();
                handleNav();
            }
        });

    },
    reunderNav: function (data) {
        let self = this;

        if (typeof(queryParam) != "undefined" && queryParam.keyword) {
            $("#key").val(html_decode(queryParam.keyword)).attr("placeholder", data.indexTopSearchPlaceHolderText[0].text);
        } else {
            $("#key").val(data.indexTopSearchPlaceHolderText[0].text).attr("placeholder", data.indexTopSearchPlaceHolderText[0].text);
        }

        let tplNavMenu = require("../../template/navMenuV2");
        let navMenuHtml = self.render(data, tplNavMenu);
        $("#categorys-2014 .dt").after(navMenuHtml);

        let tplNavItem = require("../../template/navItemV2");
        let navItemHtml = self.render(data, tplNavItem);
        $("#navitems-2014").html(navItemHtml);

        let tplHotKey = require("../../template/hotKey");
        let hotKeyHtml = self.render(data, tplHotKey);
        $("#hotwords-2014").html(hotKeyHtml);


        function html_decode(str) {
            let s = "";
            if (str.length == 0) return "";
            s = str.replace(/&lt;/g, "<");
            s = s.replace(/&gt;/g, ">");
            s = s.replace(/&apos;/g, "\'");
            s = s.replace(/&quot;/g, "\"");
            s = s.replace(/&#92;/g, "\\");
            s = s.replace(/&amp;/g, "&");
            return s;
        }
    },
    changeRoot: function () {
        $(".leaf-nav").each(function () {
            $(this).insertAfter($("#nav-2014 .w"));
        });
    },
    hover: function () {
        $("#categorys-2014").unbind("mouseenter").bind("mouseenter", function (e) {
            $(this).find(".dd").css("display", "block");
            $(this).addClass("hover");
        }).bind("mouseleave", function () {
            $(this).find(".dd").css("display", "none");
            $(this).removeClass("hover");
        });

        $("#categorys-2014 .dd").unbind("mouseenter").bind("mouseenter", function () {
            $(this).css("display", "block");
        }).bind("mouseleave", function () {
            setTimeout(function () {
                if ($("#categorys-2014").hasClass("hover")) {
                    return false;
                }
                $(this).css("display", "none");
            }, 200);
        });
    },
    handleShop: function () {
        $(".shopHeaderArea .shopInfo").bind("mouseenter", function () {
            $(".ratLayer").css("display", "block").addClass("isIn");
        }).bind("mouseleave", function () {
            $(".ratLayer").removeClass("isIn");
            setTimeout(function () {
                if ($(".ratLayer").hasClass("isIn")) {
                    return false;
                }
                $(".ratLayer").css("display", "none");
            }, 200);
        });

        $(".ratLayer").bind("mouseenter", function () {
            $(".ratLayer").addClass("isIn");
        });

        $(".ratLayer").bind("mouseleave", function () {
            $(this).css("display", "none");
        });
    },
    render: function (data, tpl) {
        let render = template.compile(tpl.tpl);
        return render(data);
    }
};

exports.handleNav = handleNav;
exports.control = control;



// WEBPACK FOOTER //
// ./src/js/unit/nav/navV2.js